module.exports = "<script async src=\"https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4215159892578693\"\n        crossorigin=\"anonymous\"></script>\n<!-- RandomRoad -->\n<ins class=\"adsbygoogle\"\n     style=\"display:inline-block;width:1200px;height:90px\"\n     data-ad-client=\"ca-pub-4215159892578693\"\n     data-ad-slot=\"7981387010\"></ins>\n<script>\n  (adsbygoogle = window.adsbygoogle || []).push({});\n</script>\n"


//////////////////
// WEBPACK FOOTER
// ./src/assets/myads.html
// module id = 2pFE
// module chunks = 1